import ApiService from '@/services/api.service'

const BuildingService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/Buildings/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
          }       
          return ApiService.customRequest(requestData);
    }, 
    Add(data){
        return ApiService.post(`/Buildings`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/Buildings/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/Buildings/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/Buildings/${Id}`);
    },
    getBuildingsByCode(parameter){
      const requestData = {
        method: 'get',
        url: "/Buildings/",
        headers: {
        },
        params: {          
          code: parameter.code           
        }
      }     
      return ApiService.customRequest(requestData);       
    },
  }


  
  export default BuildingService;